<i18n src="@/locales/modules/ActivityTranslate.json"></i18n>

<template>
    <div>
        <vs-table ref="table" class="activity-table stack-table" :sst="true" :data="data" :noDataText="$t('Notify.NoDataAvailable')" @sort="handleSortChange">
            <template slot="thead">
				<vs-th sort-key="person_id">{{ $t('Header.Id') }}</vs-th>
				<vs-th sort-key="person_name">{{ $t('Header.Fullname') }}</vs-th>
				<vs-th sort-key="department">{{ $t('Header.Room') }}</vs-th>
				<vs-th sort-key="topic_id">{{ $t('Header.Status') }}</vs-th>
				<vs-th sort-key="time">{{ $t('Header.Time') }}</vs-th>
				<vs-th sort-key="similarity">{{ $t('Header.Similarity') }}</vs-th>
				<vs-th class="no-sorter">{{ $t('Header.Image') }}</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data-header="$t('Header.Id')">
                            <p class="font-medium">{{ tr.person_id || '' }}</p>
                        </vs-td>
                        <vs-td :data-header="$t('Header.Fullname')">
                            <p class="font-medium">{{ tr.person_name || $t('Anonymous') }}</p>
                        </vs-td>
                        <vs-td :data-header="$t('Header.Room')">
                            <p class="font-medium">{{ tr.department || '' }}</p>
                        </vs-td>

                        <vs-td :data-header="$t('Header.Status')">
                            <p class="font-medium">{{ tr.topic_id === "KHUON_MAT_1" ? $t('Status.In') : $t('Status.Out') }}</p>
						</vs-td>

                        <vs-td :data-header="$t('Header.Time')">
                            <p class="font-medium">{{ formatDetectTime(tr.detect_time ) || "" }}</p>
                        </vs-td>

                        <vs-td :data-header="$t('Header.Face')">
							<p class="font-medium">{{ tr.similarity }}</p>
                        </vs-td>

                        <vs-td class="p-0" :data-header="$t('Header.Similarity')">
                            <img
                                :src="$constant.PAGE_URL_CONVERT_IMAGE + $constant.PAGE_URL_CAMERA_CMD + '/ui/config/main_img/' + tr.id"
                                :alt="tr.id"
								@click="() => handlePreview({
                                    name: tr.id,
                                    url: $constant.PAGE_URL_CONVERT_IMAGE + $constant.PAGE_URL_CAMERA_CMD + '/ui/config/obj_img/' + tr.id
                                })"
                                class="w-48 h-48"
								loading="lazy"
                            />
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
		<el-dialog v-if="dialogVisible && previewFile" class="custom-nested-dialog cbs-upload-preview" append-to-body :modal="false" :show-close="false" :visible.sync="dialogVisible">
			<div slot="title" class="flex justify-between items-center w-full">
				<span class="el-dialog__title break-all">{{ previewFile.name }}</span>
			</div>
			<PerfectScrollbar class="p-6 text-center" :settings="settings">
				<img class="responsive" :src="previewFile.url" alt="" />
			</PerfectScrollbar>

			<div class="flex justify-center" slot="footer">
				<vs-button type="border" class="w-full sm:w-1/2 lg:w-1/4 xl:w-1/5 font-bold" @click.stop="dialogVisible = false">{{ $t("Actions.Close") }}</vs-button>
			</div>
		</el-dialog>
    </div>
</template>

<script>


export default {
	name: "ActivityTable",
	components: {

	},
	props: {
		data: {
			type: Array,
			required: true
		},
		isQuickMode: Boolean,
		displayColumns: Object
	},
	emits: {
		onSortChange: {},
	},
    data() {
        return {
            dialogVisible: false,
            previewFile: null,
            settings: {
                wheelSpeed: 1,
                wheelPropagation: true,
                minScrollbarLength: 20
            }
        };
    },
	computed: {
	},
	methods: {
		formatDetectTime(detectTime) {
			const date = new Date(detectTime);
			date.setHours(date.getHours() - 7); // Chuyển từ GMT sang UTC+7
			const formattedDate = date.toLocaleString("vi-VN", {
				hour: "2-digit",
				minute: "2-digit",
				second: "2-digit",
			});
			return formattedDate.replace(", ", " ");
		},
		checkColumnDisplay(column) {
			if (this.displayColumns && this.displayColumns.hasOwnProperty(column)) {
				return this.displayColumns[column] == '1';
			}
			return true;
		},
		handleSortChange(sortKey) {
			this.$emit('onSortChange', sortKey);
		},
		handlePreview(file) {
            this.previewFile = file;
            this.dialogVisible = true;
		},
	}
};
</script>

<style lang="scss" scoped>
.custom-num-req {
	text-decoration: underline;
	cursor: help;
	padding-right: 5px;
}
</style>
